import React from 'react';
import { HeartIcon, QuoteIcon } from 'lucide-react';
import { Container } from './Container';
import { TestimonialCard } from './TestimonialCard';
import { salesProof } from '../data/salesProof';
type TestimonialsProps = {
  variant: 'featured' | 'grid';
};
function TestimonialSlot({
  n
}: {
  n: number;
}) {
  return <div role="img" aria-label={`Espacio reservado: testimonio real ${n}`} className="flex h-full min-h-[200px] flex-col items-center justify-center gap-3 rounded-3xl border-2 border-dashed border-teal/30 bg-teal-soft/40 p-6 text-center" data-id="element-438" data-mp="3azj8zj3znu5c">
      <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white text-teal-dark shadow-soft" data-id="element-439" data-mp="2x0jmoi3y7rcc">
        <QuoteIcon aria-hidden="true" className="h-5 w-5" data-id="element-440" data-mp="2s2i4s0i9dy2g" />
      </span>
      <span className="font-mono text-xs font-semibold uppercase tracking-wide text-teal-dark" data-id="element-441" data-mp="v9ga3nai02p5">[Testimonio real #{n}]</span>
      <span className="max-w-[16rem] text-xs text-navy-soft" data-id="element-442" data-mp="q9tvpaixoger">Nombre, ciudad, estrellas y cita textual o captura</span>
    </div>;
}
export function Testimonials({
  variant
}: TestimonialsProps) {
  if (variant === 'featured') {
    const items = salesProof.featuredTestimonials.slice(0, 3);
    if (items.length === 0) return null;
    return <section aria-label="Lo que dicen quienes ya lo usan" className="bg-cream py-12 sm:py-16" data-id="element-443" data-mp="79lhpokjldck">
        <Container data-id="element-444" data-mp="c73nj639jcgc">
          <ul className="grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-445" data-mp="zwfx472i5mj6">
            {items.map(t => <li key={t.name + t.city} data-id="element-446" data-mp="zysfglc69ywr">
                <TestimonialCard t={t} data-id="element-447" data-mp="14uhf0oo6zft2" />
              </li>)}
          </ul>
        </Container>
      </section>;
  }
  const items = salesProof.moreTestimonials.slice(0, 4);
  const empty = items.length === 0;
  return <section aria-labelledby="more-testimonials-title" className="bg-cream py-16 sm:py-20 lg:py-24" data-id="element-448" data-mp="v3wgt2cfkdao">
      <Container data-id="element-449" data-mp="1it7cw6iu5jih">
        <h2 id="more-testimonials-title" className="flex items-center justify-center gap-2 text-center font-heading text-[1.85rem] font-black leading-tight text-navy sm:text-4xl" data-id="element-450" data-mp="1nm0gus6hcnti">
          <HeartIcon aria-hidden="true" className="h-7 w-7 fill-pink text-pink" data-id="element-451" data-mp="1sj5vxjxdez2x" />
          Más familias que ya lo usan
        </h2>
        <ul className="scrollbar-hide -mx-5 mt-10 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 sm:mx-0 sm:grid sm:grid-cols-2 sm:gap-5 sm:overflow-visible sm:px-0" data-id="element-452" data-mp="1og9kqea5u590">
          {empty ? [1, 2, 3, 4].map(n => <li key={n} className="w-[85%] shrink-0 snap-start sm:w-auto" data-id="element-453" data-mp="1el7rb68uqh0m">
                  <TestimonialSlot n={n} data-id="element-454" data-mp="19r3motn26l2p" />
                </li>) : items.map(t => <li key={t.name + t.city} className="w-[85%] shrink-0 snap-start sm:w-auto" data-id="element-455" data-mp="14r8xcuixm3jr">
                  <TestimonialCard t={t} showProduct data-id="element-456" data-mp="10tku947354gs" />
                </li>)}
        </ul>
      </Container>
    </section>;
}